import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-50d2d9cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row items-center justify-between w-full pl-2 pr-12 text-white" }
const _hoisted_2 = { class: "opacity-50 text-accent" }
const _hoisted_3 = { class: "text-gray-500" }

import useAccess from "@/composable/useAccess";
import i18n from "@/lang/langs";
import { storageConfig, userInfos } from "@/state/api/userState";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {


	
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(useAccess)('visibility', ['Admin', 'CoAdmin'])
				?
					(_unref(userInfos)?.organisation?.slogan ?? _unref(i18n)[_unref(storageConfig).lang]?.app.footerInfoLeft ?? "Proudly developed by Mfoum Group SARL" )
				:
					_unref(userInfos)?.stations.length ? 'Agence de ' + _unref(userInfos)?.stations[0].station_name : ''), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(i18n)[_unref(storageConfig).lang]?.app.appName || "Jahagal Software") + " © copyright 2022 - " + _toDisplayString(new Date().getFullYear()), 1)
  ]))
}
}

})